import React from 'react';
import Context from '../../assets/js/Context';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { Row, Col, Form, Card, Button, Modal, Table, InputGroup, FormControl } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from 'react-toastify';
import { Checkbox, FormControlLabel, IconButton, Tooltip, Chip } from '@mui/material/';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SearchIcon from '@mui/icons-material/Search';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import FilterListIcon from '@mui/icons-material/FilterList';
import RefreshIcon from '@mui/icons-material/Refresh';
import EditIcon from '@mui/icons-material/Edit';
import 'react-toastify/dist/ReactToastify.css';
import qs from 'qs';
import * as moment from "moment-timezone";
import * as XLSX from 'xlsx';
import Login from '../common/login';

const cookies = new Cookies();

// Inline Styles
const styles = {
    container: {
        padding: '20px',
        backgroundColor: '#f8f9fa',
        minHeight: 'calc(100vh - 60px)',
        direction: 'rtl'
    },
    headerCard: {
        border: 'none',
        borderRadius: '10px',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        marginBottom: '20px',
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)'
    },
    pageTitle: {
        color: 'white',
        fontWeight: 'bold',
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        fontSize: '1.8rem'
    },
    addBtn: {
        background: 'white',
        color: '#667eea',
        border: 'none',
        borderRadius: '8px',
        padding: '10px 20px',
        fontWeight: 'bold',
        transition: 'all 0.3s ease',
        cursor: 'pointer'
    },
    filterCard: {
        border: 'none',
        borderRadius: '10px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)',
        marginBottom: '20px'
    },
    tableCard: {
        border: 'none',
        borderRadius: '10px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)',
        overflow: 'hidden'
    },
    tableHeader: {
        backgroundColor: 'white',
        padding: '15px 20px',
        borderBottom: '2px solid #f1f3f5'
    },
    modernTable: {
        marginBottom: 0,
        width: '100%'
    },
    tableHeadCell: {
        backgroundColor: '#f8f9fa',
        color: '#495057',
        fontWeight: '600',
        borderBottom: '2px solid #dee2e6',
        padding: '12px',
        whiteSpace: 'nowrap',
        textAlign: 'right'
    },
    sortableHeader: {
        cursor: 'pointer',
        userSelect: 'none',
        transition: 'background-color 0.2s'
    },
    tableRow: {
        transition: 'background-color 0.2s'
    },
    tableCell: {
        padding: '12px',
        verticalAlign: 'middle',
        borderBottom: '1px solid #f1f3f5',
        textAlign: 'right'
    },
    badge: {
        padding: '6px 12px',
        fontSize: '13px',
        fontWeight: '600',
        borderRadius: '6px',
        backgroundColor: '#28a745',
        color: 'white'
    },
    totalSection: {
        border: '2px dashed #667eea',
        background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)',
        padding: '20px',
        borderRadius: '8px',
        marginTop: '20px'
    },
    formLabel: {
        fontWeight: '600',
        color: '#495057',
        marginBottom: '8px',
        display: 'flex',
        alignItems: 'center'
    },
    formControl: {
        border: '1px solid #dee2e6',
        borderRadius: '8px',
        padding: '10px 12px',
        width: '100%',
        transition: 'all 0.3s'
    },
    searchInput: {
        border: '1px solid #dee2e6',
        borderRadius: '0 8px 8px 0',
        padding: '8px 12px'
    },
    searchIcon: {
        backgroundColor: 'white',
        border: '1px solid #dee2e6',
        borderLeft: 'none',
        borderRadius: '8px 0 0 8px',
        padding: '8px 12px'
    },
    primaryButton: {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        border: 'none',
        borderRadius: '8px',
        padding: '8px 16px',
        fontWeight: '600',
        transition: 'all 0.3s',
        color: 'white'
    },
    successButton: {
        background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
        border: 'none',
        borderRadius: '8px',
        padding: '8px 16px',
        fontWeight: '600',
        transition: 'all 0.3s',
        color: 'white'
    },
    dangerButton: {
        background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
        border: 'none',
        borderRadius: '8px',
        padding: '8px 16px',
        fontWeight: '600',
        transition: 'all 0.3s',
        color: 'white'
    },
    outlineButton: {
        color: '#11998e',
        border: '2px solid #11998e',
        background: 'transparent',
        borderRadius: '8px',
        padding: '6px 14px',
        fontWeight: '600',
        transition: 'all 0.3s'
    },
    modalHeader: {
        border: 'none',
        padding: '20px',
        borderRadius: '12px 12px 0 0'
    },
    modalBody: {
        padding: '20px'
    },
    modalFooter: {
        border: 'none',
        padding: '15px 20px',
        backgroundColor: '#f8f9fa'
    },
    pagination: {
        marginTop: '20px',
        display: 'flex',
        justifyContent: 'center',
        gap: '5px'
    },
    pageButton: {
        color: '#667eea',
        border: '1px solid #dee2e6',
        padding: '8px 14px',
        borderRadius: '6px',
        background: 'white',
        cursor: 'pointer',
        transition: 'all 0.3s'
    },
    activePageButton: {
        backgroundColor: '#667eea',
        color: 'white',
        border: '1px solid #667eea'
    },
    disabledPageButton: {
        color: '#6c757d',
        backgroundColor: '#f8f9fa',
        cursor: 'not-allowed'
    }
};

class Category extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            filteredOrders: [],
            from: new Date(),
            to: new Date(),
            spin: false,
            serch: false,
            total: 0,
            showAddModal: false,
            showDeleteModal: false,
            deleteId: null,
            searchTerm: '',
            sortConfig: { key: null, direction: 'asc' },
            currentPage: 1,
            itemsPerPage: 10,
            nameExpenses: '',
            amountExpenses: '',
            dateExpenses: moment().format('YYYY-MM-DD'),
            isAd: false,
            loading: false
        }
    }

    componentDidMount() {
        this.Orders();
    }

    DeleteCate = (id) => {
        this.setState({ loading: true });
        var header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        axios.delete(host + `dashbord/spending/${id}?`, { headers: header })
            .then(response => {
                toast.success('تم الحذف بنجاح', {
                    position: "top-center",
                    autoClose: 3000,
                });
                this.Orders();
                this.setState({ showDeleteModal: false, deleteId: null, loading: false });
            })
            .catch(error => { 
                console.log(error);
                toast.error('حدث خطأ في الحذف');
                this.setState({ loading: false });
            })
    }

    Orders = () => {
        this.setState({ spin: true });
        var date1 = moment(this.state.from).format('MM/DD/YYYY');
        var date2 = moment(this.state.to).format('MM/DD/YYYY');
        var header = { "Content-Type": "application/json", token: cookies.get("token") };

        axios.get(host + `dashbord/spending/my?from=${date1}&to=${date2}`, { headers: header })
            .then(res => {
                let arr = [];
                const data = res.data.data.spending || [];
                
                for (let i = 0; i < data.length; i++) {
                    let obj = {
                        id: data[i].id,
                        name: data[i].name,
                        amount: parseFloat(data[i].amount),
                        add_date: moment(data[i].add_at).tz('Asia/baghdad').format('YYYY/MM/DD'),
                        add_time: moment(data[i].add_at).tz('Asia/baghdad').format('LT'),
                        date: moment(data[i].createdAt).tz('Asia/baghdad').format('YYYY/MM/DD LT'),
                    };
                    arr.push(obj);
                }
                
                this.setState({
                    orders: arr,
                    filteredOrders: arr,
                    spin: false, 
                    serch: true,
                    total: res.data.data.amount || 0
                });
            })
            .catch(error => {
                console.log(error.response);
                this.setState({ spin: false });
                toast.error('حدث خطأ في جلب البيانات');
            });
    }

    handleAddExpense = () => {
        const { nameExpenses, amountExpenses, dateExpenses, isAd } = this.state;
        
        if (!nameExpenses || !amountExpenses || !dateExpenses) {
            toast.error('يرجى ملء جميع الحقول المطلوبة');
            return;
        }

        this.setState({ loading: true });
        
        axios.post(host + `dashbord/spending/add`,
            qs.stringify({
                name: nameExpenses,
                price: amountExpenses,
                date: dateExpenses,
                check: isAd ? 1 : 0
            }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded", 
                token: cookies.get("token")
            }
        })
        .then(response => {
            toast.success('تمت الإضافة بنجاح', {
                position: "top-center",
                autoClose: 3000,
            });
            this.setState({ 
                showAddModal: false,
                nameExpenses: '',
                amountExpenses: '',
                dateExpenses: moment().format('YYYY-MM-DD'),
                isAd: false,
                loading: false
            });
            this.Orders();
        })
        .catch(error => {
            toast.error("حصل خطأ تأكد من المعلومات");
            console.log(error);
            this.setState({ loading: false });
        })
    }

    handleSearch = (e) => {
        const searchTerm = e.target.value.toLowerCase();
        this.setState({ searchTerm });
        
        if (searchTerm === '') {
            this.setState({ filteredOrders: this.state.orders });
        } else {
            const filtered = this.state.orders.filter(order => 
                order.name.toLowerCase().includes(searchTerm) ||
                order.amount.toString().includes(searchTerm) ||
                order.add_date.includes(searchTerm)
            );
            this.setState({ filteredOrders: filtered, currentPage: 1 });
        }
    }

    handleSort = (key) => {
        let direction = 'asc';
        if (this.state.sortConfig.key === key && this.state.sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        
        const sorted = [...this.state.filteredOrders].sort((a, b) => {
            if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
            if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
            return 0;
        });
        
        this.setState({ 
            filteredOrders: sorted,
            sortConfig: { key, direction }
        });
    }

    exportToExcel = () => {
        const dataToExport = this.state.filteredOrders.map(order => ({
            'رقم المصروف': order.id,
            'اسم المصروف': order.name,
            'المبلغ': order.amount,
            'التاريخ': order.add_date,
            'الوقت': order.add_time
        }));

        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "المصروفات");
        
        const maxWidth = dataToExport.reduce((w, r) => Math.max(w, r['اسم المصروف'].length), 10);
        ws['!cols'] = [
            { wch: 15 },
            { wch: maxWidth },
            { wch: 15 },
            { wch: 15 },
            { wch: 10 }
        ];
        
        XLSX.writeFile(wb, `المصروفات_${moment().format('YYYY-MM-DD')}.xlsx`);
        toast.success('تم تصدير الملف بنجاح');
    }

    getCurrentPageData = () => {
        const { currentPage, itemsPerPage, filteredOrders } = this.state;
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        return filteredOrders.slice(indexOfFirstItem, indexOfLastItem);
    }

    paginate = (pageNumber) => this.setState({ currentPage: pageNumber });

    render() {
        if (!cookies.get("token")) {
            return <Login />;
        }

        const { 
            showAddModal, 
            showDeleteModal, 
            spin, 
            serch, 
            total, 
            filteredOrders,
            currentPage,
            itemsPerPage,
            loading
        } = this.state;

        const currentData = this.getCurrentPageData();
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(filteredOrders.length / itemsPerPage); i++) {
            pageNumbers.push(i);
        }

        return (
            <Context.Consumer>
                {ctx => {
                    return (
                        <div style={styles.container}>
                            {/* Header Section */}
                            <Card style={styles.headerCard}>
                                <Card.Body>
                                    <Row className="align-items-center">
                                        <Col md={6}>
                                            <h2 style={styles.pageTitle}>
                                                <AttachMoneyIcon style={{ marginLeft: '10px', fontSize: '2rem' }} />
                                                إدارة المصروفات
                                            </h2>
                                        </Col>
                                        <Col md={6} style={{ textAlign: 'left' }}>
                                            <Button 
                                                style={styles.addBtn}
                                                onMouseEnter={(e) => {
                                                    e.target.style.transform = 'translateY(-2px)';
                                                    e.target.style.boxShadow = '0 5px 15px rgba(102, 126, 234, 0.4)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.transform = 'translateY(0)';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                                onClick={() => this.setState({ showAddModal: true })}
                                            >
                                                <AddCircleOutlineIcon style={{ marginLeft: '8px' }} />
                                                إضافة مصروف جديد
                                            </Button>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>

                            {/* Filter Section */}
                            <Card style={styles.filterCard}>
                                <Card.Body>
                                    <Row className="align-items-end">
                                        <Col md={3}>
                                            <Form.Group>
                                                <Form.Label style={styles.formLabel}>
                                                    <CalendarTodayIcon style={{ fontSize: '18px', marginLeft: '5px' }} />
                                                    من تاريخ
                                                </Form.Label>
                                                <DatePicker
                                                    className="form-control"
                                                    style={styles.formControl}
                                                    dateFormat="dd/MM/yyyy"
                                                    selected={this.state.from}
                                                    onChange={(date) => this.setState({ from: date })}
                                                    placeholderText="اختر التاريخ"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group>
                                                <Form.Label style={styles.formLabel}>
                                                    <CalendarTodayIcon style={{ fontSize: '18px', marginLeft: '5px' }} />
                                                    إلى تاريخ
                                                </Form.Label>
                                                <DatePicker
                                                    className="form-control"
                                                    style={styles.formControl}
                                                    dateFormat="dd/MM/yyyy"
                                                    selected={this.state.to}
                                                    onChange={(date) => this.setState({ to: date })}
                                                    placeholderText="اختر التاريخ"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <InputGroup style={{ borderRadius: '8px', overflow: 'hidden' }}>
                                                <InputGroup.Text style={styles.searchIcon}>
                                                    <SearchIcon />
                                                </InputGroup.Text>
                                                <FormControl
                                                    style={styles.searchInput}
                                                    placeholder="ابحث عن مصروف..."
                                                    value={this.state.searchTerm}
                                                    onChange={this.handleSearch}
                                                />
                                            </InputGroup>
                                        </Col>
                                        <Col md={2}>
                                            <Button 
                                                style={styles.successButton}
                                                className="w-100"
                                                onClick={this.Orders}
                                                disabled={spin}
                                            >
                                                {spin ? (
                                                    <span className="spinner-border spinner-border-sm" style={{ marginLeft: '8px' }}></span>
                                                ) : (
                                                    <FilterListIcon style={{ marginLeft: '8px' }} />
                                                )}
                                                تطبيق الفلتر
                                            </Button>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>

                            {/* Table Section */}
                            {serch && (
                                <Card style={styles.tableCard}>
                                    <div style={styles.tableHeader}>
                                        <Row className="align-items-center">
                                            <Col md={6}>
                                                <h5 style={{ margin: 0, fontWeight: 'bold' }}>
                                                    قائمة المصروفات
                                                    <Chip 
                                                        label={`${filteredOrders.length} مصروف`}
                                                        color="primary"
                                                        size="small"
                                                        style={{ marginRight: '10px' }}
                                                    />
                                                </h5>
                                            </Col>
                                            <Col md={6} style={{ textAlign: 'left' }}>
                                                <Button 
                                                    style={{ ...styles.outlineButton, marginLeft: '10px' }}
                                                    size="sm"
                                                    onClick={this.exportToExcel}
                                                >
                                                    <FileDownloadIcon style={{ marginLeft: '5px' }} />
                                                    تصدير Excel
                                                </Button>
                                                <Button 
                                                    style={{ ...styles.outlineButton, border: '2px solid #667eea', color: '#667eea' }}
                                                    size="sm"
                                                    onClick={this.Orders}
                                                >
                                                    <RefreshIcon style={{ marginLeft: '5px' }} />
                                                    تحديث
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Card.Body>
                                        <div className="table-responsive">
                                            <Table hover style={styles.modernTable}>
                                                <thead>
                                                    <tr>
                                                        <th 
                                                            style={{ ...styles.tableHeadCell, ...styles.sortableHeader }}
                                                            onClick={() => this.handleSort('id')}
                                                        >
                                                            # {this.state.sortConfig.key === 'id' && (
                                                                this.state.sortConfig.direction === 'asc' ? '▲' : '▼'
                                                            )}
                                                        </th>
                                                        <th 
                                                            style={{ ...styles.tableHeadCell, ...styles.sortableHeader }}
                                                            onClick={() => this.handleSort('name')}
                                                        >
                                                            اسم المصروف {this.state.sortConfig.key === 'name' && (
                                                                this.state.sortConfig.direction === 'asc' ? '▲' : '▼'
                                                            )}
                                                        </th>
                                                        <th 
                                                            style={{ ...styles.tableHeadCell, ...styles.sortableHeader }}
                                                            onClick={() => this.handleSort('amount')}
                                                        >
                                                            المبلغ {this.state.sortConfig.key === 'amount' && (
                                                                this.state.sortConfig.direction === 'asc' ? '▲' : '▼'
                                                            )}
                                                        </th>
                                                        <th 
                                                            style={{ ...styles.tableHeadCell, ...styles.sortableHeader }}
                                                            onClick={() => this.handleSort('add_date')}
                                                        >
                                                            التاريخ {this.state.sortConfig.key === 'add_date' && (
                                                                this.state.sortConfig.direction === 'asc' ? '▲' : '▼'
                                                            )}
                                                        </th>
                                                        <th style={styles.tableHeadCell}>الوقت</th>
                                                        {/* <th style={{ ...styles.tableHeadCell, textAlign: 'center' }}>الإجراءات</th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {currentData.length > 0 ? (
                                                        currentData.map((order, index) => (
                                                            <tr 
                                                                key={order.id}
                                                                style={styles.tableRow}
                                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                                            >
                                                                <td style={styles.tableCell}>{order.id}</td>
                                                                <td style={{ ...styles.tableCell, fontWeight: 'bold' }}>{order.name}</td>
                                                                <td style={styles.tableCell}>
                                                                    <span style={styles.badge}>
                                                                        {order.amount.toLocaleString()} د.ع
                                                                    </span>
                                                                </td>
                                                                <td style={styles.tableCell}>{order.add_date}</td>
                                                                <td style={styles.tableCell}>{order.add_time}</td>
                                                                <td style={{ ...styles.tableCell, textAlign: 'center' }}>
                                                                    <Tooltip title="تعديل">
                                                                        <IconButton size="small" color="primary">
                                                                            <EditIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    <Tooltip title="حذف">
                                                                        <IconButton 
                                                                            size="small" 
                                                                            color="error"
                                                                            onClick={() => this.setState({ 
                                                                                showDeleteModal: true, 
                                                                                deleteId: order.id 
                                                                            })}
                                                                        >
                                                                            <DeleteForeverIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="6" style={{ ...styles.tableCell, textAlign: 'center', padding: '40px' }}>
                                                                لا توجد بيانات للعرض
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>
                                        </div>

                                        {/* Pagination */}
                                        {pageNumbers.length > 1 && (
                                            <div style={styles.pagination}>
                                                <button 
                                                    style={{ 
                                                        ...styles.pageButton, 
                                                        ...(currentPage === 1 ? styles.disabledPageButton : {})
                                                    }}
                                                    onClick={() => currentPage > 1 && this.paginate(currentPage - 1)}
                                                    disabled={currentPage === 1}
                                                >
                                                    السابق
                                                </button>
                                                {pageNumbers.map(number => (
                                                    <button
                                                        key={number}
                                                        onClick={() => this.paginate(number)}
                                                        style={{ 
                                                            ...styles.pageButton,
                                                            ...(currentPage === number ? styles.activePageButton : {})
                                                        }}
                                                    >
                                                        {number}
                                                    </button>
                                                ))}
                                                <button 
                                                    style={{ 
                                                        ...styles.pageButton,
                                                        ...(currentPage === pageNumbers.length ? styles.disabledPageButton : {})
                                                    }}
                                                    onClick={() => currentPage < pageNumbers.length && this.paginate(currentPage + 1)}
                                                    disabled={currentPage === pageNumbers.length}
                                                >
                                                    التالي
                                                </button>
                                            </div>
                                        )}

                                        {/* Total Section */}
                                        <div style={styles.totalSection}>
                                            <Row>
                                                <Col md={6}>
                                                    <h5 style={{ margin: 0, color: '#495057' }}>إجمالي المصروفات</h5>
                                                </Col>
                                                <Col md={6} style={{ textAlign: 'left' }}>
                                                    <h4 style={{ margin: 0, color: '#667eea', fontWeight: 'bold' }}>
                                                        {Number(total).toLocaleString()} د.ع
                                                    </h4>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Card.Body>
                                </Card>
                            )}

                            {/* Add Modal */}
                            <Modal 
                                show={showAddModal} 
                                onHide={() => this.setState({ showAddModal: false })}
                                centered
                                style={{ direction: 'rtl' }}
                            >
                                <Modal.Header 
                                    closeButton 
                                    style={{ ...styles.modalHeader, background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}
                                >
                                    <Modal.Title>إضافة مصروف جديد</Modal.Title>
                                </Modal.Header>
                                <Modal.Body style={styles.modalBody}>
                                    <Form>
                                        <Form.Group className="mb-3">
                                            <Form.Label style={styles.formLabel}>اسم المصروف *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                style={styles.formControl}
                                                placeholder="أدخل اسم المصروف"
                                                value={this.state.nameExpenses}
                                                onChange={(e) => this.setState({ nameExpenses: e.target.value })}
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label style={styles.formLabel}>المبلغ *</Form.Label>
                                            <Form.Control
                                                type="number"
                                                step="0.01"
                                                style={styles.formControl}
                                                placeholder="أدخل المبلغ"
                                                value={this.state.amountExpenses}
                                                onChange={(e) => this.setState({ amountExpenses: e.target.value })}
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label style={styles.formLabel}>التاريخ *</Form.Label>
                                            <Form.Control
                                                type="date"
                                                style={styles.formControl}
                                                value={this.state.dateExpenses}
                                                onChange={(e) => this.setState({ dateExpenses: e.target.value })}
                                            />
                                        </Form.Group>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={this.state.isAd}
                                                    onChange={(e) => this.setState({ isAd: e.target.checked })}
                                                />
                                            }
                                            label="إضافة كـ ترويج"
                                        />
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer style={styles.modalFooter}>
                                    <Button 
                                        variant="secondary"
                                        onClick={() => this.setState({ showAddModal: false })}
                                    >
                                        إلغاء
                                    </Button>
                                    <Button 
                                        style={styles.primaryButton}
                                        onClick={this.handleAddExpense}
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm" style={{ marginLeft: '8px' }}></span>
                                                جاري الإضافة...
                                            </>
                                        ) : 'إضافة المصروف'}
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            {/* Delete Confirmation Modal */}
                            {/* <Modal 
                                show={showDeleteModal} 
                                onHide={() => this.setState({ showDeleteModal: false })}
                                centered
                                style={{ direction: 'rtl' }}
                            >
                                <Modal.Header 
                                    closeButton 
                                    style={{ ...styles.modalHeader, background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', color: 'white' }}
                                >
                                    <Modal.Title>تأكيد الحذف</Modal.Title>
                                </Modal.Header>
                                <Modal.Body style={styles.modalBody}>
                                    <p style={{ fontSize: '16px' }}>هل أنت متأكد من حذف هذا المصروف؟</p>
                                    <p style={{ color: '#dc3545', fontWeight: 'bold' }}>لا يمكن التراجع عن هذا الإجراء!</p>
                                </Modal.Body>
                                <Modal.Footer style={styles.modalFooter}>
                                    <Button 
                                        variant="secondary"
                                        onClick={() => this.setState({ showDeleteModal: false })}
                                    >
                                        إلغاء
                                    </Button>
                                    <Button 
                                        style={styles.dangerButton}
                                        onClick={() => this.DeleteCate(this.state.deleteId)}
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm" style={{ marginLeft: '8px' }}></span>
                                                جاري الحذف...
                                            </>
                                        ) : 'حذف'}
                                    </Button>
                                </Modal.Footer>
                            </Modal> */}

                            <ToastContainer
                                position="top-center"
                                autoClose={3000}
                                hideProgressBar={false}
                                newestOnTop={false}
                                closeOnClick
                                rtl={true}
                                pauseOnVisibilityChange
                                draggable
                                pauseOnHover
                                style={{ zIndex: 9999 }}
                            />
                        </div>
                    )
                }}
            </Context.Consumer>
        )
    }
}

export default Category;